export const seFbclid = () => {
    const params = new URLSearchParams(window.location.search);
    const fbclidParam = params.get('fbclid');
    return fbclidParam;
}